var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import "../TextField/index.js";
import { Field } from "./Field.js";
import { TextField as TextField$1 } from "../TextField/TextField.js";
class TextField extends Field {
  constructor() {
    super(...arguments);
    __publicField(this, "children", (fieldProps) => {
      const { innerTextFieldProps } = this.props;
      const { field, meta } = fieldProps;
      return /* @__PURE__ */ jsx(
        TextField$1,
        __spreadProps(__spreadValues(__spreadValues({}, innerTextFieldProps), field), {
          errorMessage: meta.touched && meta.error || "",
          onChange: (ev, newValue) => this._handleChange(fieldProps, ev, newValue),
          onFocus: () => {
            fieldProps.form.setFieldTouched(field.name, true, false);
          }
        })
      );
    });
    __publicField(this, "_handleChange", (props, ev, newValue) => {
      props.form.setFieldValue(props.field.name, newValue || "");
      this.props.innerTextFieldProps.onChange && this.props.innerTextFieldProps.onChange(ev, newValue);
    });
  }
}
export {
  TextField
};
//# sourceMappingURL=TextField.js.map
